<template>

    <div class="panel panel-info">
        <!-- Default panel contents -->
        <div class="panel-heading">Project Details</div>

        <!-- Table -->
        <table class="table projectLists">

            <thead>
                <tr>
                    <td class="col-sm-1">ID</td>
                    <td class="col-sm-4">Name</td>
                    <td class="col-sm-1">Type</td>
                    <td class="col-sm-1">Last Update</td>
                    <td class="col-sm-2">Updated By</td>
                    <td class="col-sm-3">Actions</td>
                </tr>
            </thead>

            <tbody>
                <tr v-for="project in projects" :key="project.projectID" :class="{'lockedRow':project.IsLocked}">
                    <td>{{project.projectID}}</td>
                    <td>{{project.projectName}}</td>
                    <td>{{project.projectType | projectTypeMap}}</td>
                    <td>{{project.lastUpdate}}</td>
                    <td>{{project.updateBy}}</td>
                    <td>
                        <router-link activeClass="active" tag="a" v-if="project.projectType === 1"
                        :to="{
                            name: 'pgnatConfig',
                            query: {
                                projectID: project.projectID,
                                cipID: cipID
                            }
                        }" >
                            <button class="btn btn-sm btn-primary" title="Edit project">
                                <template v-if="!project.IsLocked">Edit</template>
                                <template v-else>Preview</template>
                            </button>
                        </router-link>
                        <router-link activeClass="active" tag="a" v-if="project.projectType === 2"
                        :to="{
                            name: 'gnatConfig',
                            query: {
                                projectID: project.projectID,
                                cipID: cipID
                            }
                        }" >
                            <button class="btn btn-sm btn-primary" title="Edit project">
                                <template v-if="!project.IsLocked">Edit</template>
                                <template v-else>Preview</template>
                            </button>
                        </router-link>
                        <router-link activeClass="active" tag="a" v-if="project.projectType === 3"
                        :to="{
                            name: 'aptConfig',
                            query: {
                                projectID: project.projectID,
                                cipID: cipID
                            }
                        }" >
                            <button class="btn btn-sm btn-primary" title="Edit project">
                                <template v-if="!project.IsLocked">Edit</template>
                                <template v-else>Preview</template>
                            </button>
                        </router-link>
                        <button class="btn btn-sm btn-primary" @click="copyProject(project)" title="Duplicate project">Copy</button>
                        <button class="btn btn-sm btn-primary" @click="testProject(project)" title="Test project">Test</button>
                        <button class="btn btn-sm btn-warning" @click="deleteProject(project.projectID)" :disabled="project.IsLocked" title="Delete project">Delete</button>
                        <button class="btn btn-sm btn-primary" @click="lockUnlockProject(project.projectID, project.IsLocked)" :title="project.IsLocked ? 'Unlock project':'Lock project'">
                            <template v-if="!project.IsLocked">Lock</template>
                            <template v-else>Unlock</template>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Edit fields - Confirmation Modal -->
        <div
        class="modal modal--confirmation fade"
        style="display: block"
        :class="{ in: showConfirmationModal }"
        v-if="showConfirmationModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="confirmationModalLabel"
        aria-hidden="true"
        >
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <button
                type="button"
                @click="showConfirmationModal = false"
                class="close"
                data-dismiss="modal"
                aria-hidden="true"
                >
                &times;
                </button>
                <h4 class="modal-title" id="confirmationModalLabel">
                Unlock a project
                </h4>
            </div>
            <div class="modal-body">
                <p>Do you have approval to unlock this project and make changes?</p>
            </div>
            <div class="modal-footer">
                <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
                @click="showConfirmationModal = false"
                >
                No
                </button>
                <button
                type="button"
                class="btn btn-primary"
                @click="lockUnlockProjectTrigger(unlockProjectId, true)"
                >
                Yes
                </button>
            </div>
            </div>
        </div>
        </div>
        <div
        class="modal-backdrop fade"
        :class="{ in: showConfirmationModal }"
        v-show="showConfirmationModal"
        @click="showConfirmationModal = false"
        ></div>
    </div>
</template>

<script>

    import {eventBus} from '../../main.js';
    import * as utils from '../../utils.js';

    export default {
        data () {
            return {
                projects:[],
                link: {
                    name: 'pgnatConfig',
                    query: {
                        locale: 'en',
                        q: 100
                    },
                    hash: '#data'
                },
                hsCookie: {},
                email: '',
                hsName: '',
                adminID: 0,
                wsHeader: 'https://iat.hotspexeurope.com/service.asmx/',
                appBlockElm: document.getElementById("appBlock"),
                generalObj: {
                    lockProject: true
                },
                showConfirmationModal: false,
                unlockProjectId: null
            }
        },
        props: ['cipID'],
        methods: {
            deleteProject(projectID)
            {
                console.log('projectID: '  + projectID);

                this.appBlockElm.classList.remove("hidden");

                var self = this;

                setTimeout(function(){

                    if(confirm('Are you sure you want to delete this project?'))
                    {
                        // delete current project

                        var data = JSON.stringify({'projectID': projectID});
                        self.$http
                            .post(self.wsHeader + 'deleteImplicitProject', data)
                            .then(response => response.json())
                            .then(data => {
                                if(data)
                                {
                                    console.log('data: ' + JSON.stringify(data));

                                    const project = self.projects.find(element => element.projectID === projectID);
                                    self.projects.splice(self.projects.indexOf(project), 1);
                                }
                            });

                        self.appBlockElm.classList.add("hidden");
                    }
                    else
                    {
                        self.appBlockElm.classList.add("hidden");
                    }

                }, 150);
            },
            testProject(project)
            {
                let testURL;

                if(project.projectType === 1) {
                    testURL = 'https://apps.hotspexeurope.com/ext/mob/packspex/pgnat/index.html?projectID=' + project.projectID;
                }
                else if(project.projectType === 2)
                {
                    testURL = 'https://apps.hotspexeurope.com/ext/mob/packspex/gnat/index.html?projectID=' + project.projectID;
                }
                else if(project.projectType === 3)
                {
                    testURL = 'https://apps.hotspexeurope.com/ext/mob/packspex/apt/index.html?projectID=' + project.projectID;
                }

                window.open(testURL, '_blank');
            },
            async copyProject(project)
            {
                this.appBlockElm.classList.remove("hidden");

                if(this.hsName === '')
                {
                    await this.getUserEmail();
                }

                var self = this;
                setTimeout(function(){

                    var projectName = prompt('Please input your project name', '');

                    if (projectName != null) {

                        let targetProject = {'projectID': project.projectID, 'projectName': projectName, 'updatedBy': self.adminID};

                        console.log('targetProject: ' + JSON.stringify(targetProject));

                        self.$http
                            .post(self.wsHeader + 'ImplicitCopyProject', JSON.stringify({userdata: targetProject}))
                            .then(response => response.json())
                            .then(data => {
                                if(data)
                                {
                                    // console.log('data: ' + JSON.stringify(data));

                                    // var newProject = {'ProjectID': data.d.projectID,'ProjectName': data.d.projectName,'ProjectType': data.d.projectType,'Completes': 0, 'Lastupdate': data.d.lastUpdated,'Updatedby': self.hsName};

                                    // self.projects.push(newProject);
                                    self.getProjectList()

                                    self.appBlockElm.classList.add("hidden");
                                }
                            });
                    }
                    else
                    {
                        self.appBlockElm.classList.add("hidden");
                    }

                }, 100);


            },
            async getUserEmail()
            {
                var response = await utils.readCookie("HOTSPEXAWESOME");

                if((response && response.success)) {
                    this.hsCookie = response.data;
                    if(this.hsCookie)
                    {
                        let hsCookie = utils.queryStringToJSON(this.hsCookie);
                        console.log('hsCookie: ' + hsCookie);

                        this.email = hsCookie.email;
                        this.hsName = hsCookie.name;
                        this.adminID = hsCookie.adminID
                    }
                    else
                    {
                        if(window.location.href.indexOf('http://localhost:8008') !== -1)
                        {
                            this.email = 'devs@hotspexeurope.com';
                            this.hsName = 'Devs';
                            this.adminID = 64;
                        }
                        else
                        {
                            alert('Please log in https://awesome.hotspexeurope.com/ site first before continue');
                        }
                    }
                } else {
                    setTimeout(function () {
                        alert(response.message)
                        window.open('https://awesome.hotspexeurope.com/', '_self')
                    })
                }
            },
            addLoadingBlock()
            {

                this.appBlockElm.classList.remove("hidden");
                // this.appContainer.classList.add('hideScrollbar');
            },
            removeLoadingBlock()
            {
                this.appBlockElm.classList.add("hidden");
                // this.appContainer.classList.remove('hideScrollbar');
            },
            getProjectList()
            {
                var data = {'cipid': this.cipID};

                this.$http
                    .post(this.wsHeader + 'getImplicitProjects', data)
                    .then(response => response.json())
                    .then(data => {
                        if(data)
                        {
                            console.log('getImplicitProjects: ' + JSON.stringify(data));
                            this.projects = data;
                        }

                        this.removeLoadingBlock();
                    });
            },
            async lockUnlockProject(projectId, projectLockUnlock) {
                if(this.hsName === '') await this.getUserEmail();

                if(projectLockUnlock === true){
                    this.unlockProjectId = projectId
                    this.showConfirmationModal = true
                }else{
                    this.lockUnlockProjectTrigger(projectId, projectLockUnlock)
                }
            },

            lockUnlockProjectTrigger(projectId, projectLockUnlock){
                this.$http
                    .post(
                        this.wsHeader + "setStatus",
                        JSON.stringify({ ProjectId: projectId, UpdatedBy: this.adminID, IsLocked: !projectLockUnlock })
                    )
                    .then((response) => response.json())
                    .then(() => {
                        this.getProjectList();
                        this.unlockProjectId = null
                        this.showConfirmationModal = false
                });
            }
        },
        watch: {
            cipID: function()
            {
                this.addLoadingBlock();

                // GET PROJECTS UNDER CIP
                this.getProjectList();
            }
        },
        created ()
        {
            eventBus.$on('updateProjectList', (project) => {
                this.getProjectList();
            });
             var route = this.$route.query.cipID
             if (route){
                this.cipID = this.$route.query.cipID
                this.getProjectList();
             }
        }
    }

</script>

<style lang="scss" scoped>
    .projectLists .btn-sm
    {
        min-width: 50px;
        padding: 5px;
    }

    table
    {
        text-align: center;
        tr{
            &.lockedRow{
                background: #f6f6f6;
                color: #6e7881;
            }
        }
    }

    thead
    {
        font-weight: 700;
    }

    table>tbody>tr>td
    {
        height: 30px;
        line-height: 30px;
    }

    .panel
    {
        margin-top: 20px;
    }

    .modal {
        &--confirmation {
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            right: auto;
            bottom: auto;
        }
        .modal-dialog {
            margin: 25px;
        }
        .modal-content {
            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
            border: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// ProjectList.vue?f6def8c2